import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Button, Dialog } from 'lib/cortiUI';
export const DiscardDialog = ({ isOpen, onClose, onDiscard }) => {
    const { t } = useTranslation('manualAssessment', { keyPrefix: 'discardDialog' });
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, title: t('title', 'Discard Assessment?'), helperText: t('description', 'All assessment data will be lost and the assessment will be deleted. This action cannot be undone.'), actionButtons: React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "text", onClick: onClose }, t('back', 'Back')),
            React.createElement(Button, { variant: "contained", color: "error", onClick: onDiscard }, t('discard', 'Discard'))) }));
};
